export const clearEmptyKeys = (object: Object) => {
  return Object.entries(object).reduce((acc, [k, v]) => (v ? { ...acc, [k]: v } : acc), {});
};

export const genericClearEmptyKeys = <R>(object: Object): R => {
  return Object.entries(object).reduce((acc, [k, v]) => (v ? { ...acc, [k]: v } : acc), {}) as R;
};
